<template>
  <div class="content select-lang">
    <div class="header" @click="handleOpenItmes">
      <img :src="img" alt="" />
      <p>{{text}}</p>
      <i class="fa fa-angle-down" style="font-size: 22px"></i>
    </div>
    <div
      class="items shadow-sm bg-white rounded"
      v-if="openItem"
    >
      <div class="item" v-for="(option, index) in options" :key="index" @click="handleLang(option)">
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  lang as langApi
} from  '@/api/lang'
import {
  mapGetters
} from 'vuex'
export default {
  data() {
    return {
      selected: null,
      img:"/assets/image/lang/us.jpg",
      text:"U.S",
      options: [
        { value: "en", text: "English", img:'/assets/image/lang/us.jpg', name:"U.S"},
        { value: "cn", text: "中文", img:'/assets/image/lang/cn.jpg', name:"中国" },        
        { value: "in", text: "हिंदी", img:'/assets/image/lang/in.jpg', name:"हिंदी"},
        { value: "vn", text: "Tiếng Việt", img:'/assets/image/lang/vn.jpg', name:"Tiếng Việt" },
        { value: "my", text: "Malaysia", img:'/assets/image/lang/my.jpg', name:"Malaysia" },
      ],
      optionsSelect: [

      ],
      openItem: false,
      loadState: false
    };
  },
  computed: {
    ...mapGetters([
      'langs',
    ])
  },
  created() {
    console.log(this.langs)
    let item = null;
    this.options.map(option => {
        if(option.value == this.langs){
          item = option
        }
    })
    if(item){
      this.img = item.img
      this.text = item.name
      this.loadData()
      
      this.handleLang(item)
      this.$i18n.locale = this.langs
      this.loadState = true
    }
  },  
  methods: {
    handleOpenItmes() {
      this.openItem = !this.openItem;
    },
    handleCloseItems() {
      this.openItem = false;
    },
    loadData(){
      // langApi().then(rep => {
      //   console.log(rep)
      //   let data = rep.data
      //   Object.keys(data).map(item =>{
      //     this.$i18n.setLocaleMessage(item, Object.assign(data[item]))
      //   })
      //   // this.$i18n.locale = item.value
      // })
    },  
    handleLang(item) {
      // console.log(item)
      
      // // this.$nextTick(function () {
      // //   this.img = item.img
      // //   this.text = item.name
        
      // //   // this.handleCloseItems()
        
      // // })
      if(this.loadState){
        // this.$i18n.locale = item.value
        this.$store.dispatch('app/setLang', item.value)
        // this.$i18n.locale = item.value
        window.location.reload()

      } else {
        // this.$i18n.locale = item.value
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 180px;
  padding: 6px 0px;
  border-radius: 8px;
  border: 1px solid #333;
  img {
    width: 36px;
    height: 20px;
  }
  p {
    // margin: 0;
    padding: 0;
    margin: 0 8px;
  }
}
.items {
  margin-top: 10px;
  border: 1px solid rgb(119, 119, 119);
  width: 160px;
  padding: 8px 0px;
  border-radius: 6px;
  position:absolute;
  z-index: 999;
  .item {
    width: 100%;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .item:hover {
    background: $primary;
  }
}
.dropdown-toggle::after {
  display: none;
}
</style>